import logo from "./logo.svg";
import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";
import { useTheme } from "./contexts/ThemeContext";
import Work from "./pages/Work";
import Home from "./pages/Home";
import Notes from "./pages/Notes";

function App() {
  return (
    <ThemeProvider>
      <Main />
    </ThemeProvider>
  );
}

const Main = () => {
  const { mode } = useTheme();

  return (
    <BrowserRouter>
      <div
        className={`App ${
          mode === "light"
            ? "bg-white text-gray-900"
            : "bg-gray-900 text-gray-200"
        } min-h-screen transition-colors duration-300`}
      >
        <Navbar /> {/* Include the Navbar for navigation */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/work" element={<Work />} />
          <Route path="/notes" element={<Notes />} />
        </Routes>
        <Footer /> {/* Include the Footer if needed */}
      </div>
    </BrowserRouter>
  );
};

export default App;
